import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, withStyles } from "@material-ui/core";
import { compose } from "recompose";
import { isNullOrEmpty, sortByKey, useQuery } from "../../utils/helpers";
import DriverRow from './DriverRow';
import { sortAscending, sortDescending } from '../../utils/staticData';
import DriversTableHeader from './DriversTableHeader';
import InfiniteScroll from './../Common/InfiniteScroll';
import TableContainerWithHeight from "../Common/TableContainerWithHeight";

const useStyles = theme => ({
  cell: {
    textAlign: "center",
    padding: theme.spacing(1)
  },
  iconCell: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2.8),
  },
  twoIconsCell: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  medalIconCell: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1.8),
    paddingRight: theme.spacing(1.5),
  },
  starIconCell: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2),
  },
  driverRowHeight: {
    height: 65
  },
  driverNameCell: {
    justifyContent: "left",
    padding: theme.spacing(1)
  },
  driverNameRowCell: {
    justifyContent: "left",
    padding: theme.spacing(2)
  },
  bestTrophyIcon: {
    height: 40,
    width: 40,
    marginTop: theme.spacing(0.4),
    paddingLeft: theme.spacing(0),
  },
  bigTrophyIcon: {
    height: 40,
    width: 40,
    marginTop: theme.spacing(0.4),
    paddingRight: theme.spacing(0),
  },
  mediumTrophyIcon: {
    height: 30,
    width: 30,
    marginTop: theme.spacing(0.6),
    paddingLeft: theme.spacing(0),
  },
  smallTrophyIcon: {
    height: 25,
    width: 25,
    marginTop: theme.spacing(0.8),
    paddingLeft: theme.spacing(0),
  },
  noTrophyIcon: {
    height: 25,
    width: 25,
    marginTop: theme.spacing(0.8),
    paddingLeft: theme.spacing(0),
    opacity: 0.2
  }

});

const DriversTable = props => {
  const { classes, drivers, onDetailsClick, onEcoGradeClick, searchedDriver, height } = props;
  const [order, setOrder] = useState(sortDescending);
  const [activeEcoOrder, setActiveEcoOrder] = useState(true);
  const [trophyOrder, setTrophyOrder] = useState(sortDescending);
  const [activeTrophyOrder, setActiveTrophyOrder] = useState(false);
  const [internalDrivers, setInternalDrivers] = useState(drivers);
  const [dummyState, setDummyState] = useState(false); // dummy tag to rerender list after sort order change
  const query = useQuery();

  useEffect(() => {
    let filteredDrivers = drivers;
    if (query.get("id") !== null)
      return setInternalDrivers(filteredDrivers.filter(driver => driver.kierowca_id.toString() === query.get("id")));
    if (!isNullOrEmpty(searchedDriver)) {
      filteredDrivers = filteredDrivers.filter(driver => {
        if (driver.kierowca_nazwa && driver.kierowca_nazwa.toLowerCase().includes(searchedDriver.toLowerCase()))
          return driver;
        else if (driver.kierowca_rfid && driver.kierowca_rfid.toLowerCase().includes(searchedDriver.toLowerCase()))
          return driver;
      });
    }
    let sortedDrivers = sortByKey(filteredDrivers, order, "kierowca_eco");
    setInternalDrivers(sortedDrivers);
  }, [drivers, searchedDriver]);


  useEffect(() => {
    let sortedDrivers = sortByKey(internalDrivers, order, "kierowca_eco");
    setInternalDrivers(sortedDrivers);
    setDummyState(!dummyState);
    setActiveTrophyOrder(false);
    setActiveEcoOrder(true);
  }, [order]);

  const handleSortChange = () => {
    if (order === sortAscending)
      setOrder(sortDescending);
    else setOrder(sortAscending);
  };

  const handleSortTrophyChange = () => {
    if (trophyOrder === sortAscending)
      setTrophyOrder(sortDescending);
    else setTrophyOrder(sortAscending);

    const sortedDrivers = sortByKey(internalDrivers, trophyOrder, "trofeum");
    setInternalDrivers(sortedDrivers);
    setDummyState(!dummyState);
    setActiveEcoOrder(false);
    setActiveTrophyOrder(true);
  };


  return (
    <TableContainerWithHeight height={height}>
      <Table stickyHeader>
        <DriversTableHeader
          order={order}
          onSortOrderChange={handleSortChange}
          isEcoOrderActive={activeEcoOrder}
          isTrophyOrderActive={activeTrophyOrder}
          trophyOrder={trophyOrder}
          onSortTrophyOrderChange={handleSortTrophyChange}/>
        <TableBody>
          <InfiniteScroll
            initialCount={20}
            colSpan={10}
            elements={internalDrivers}
            RowComponent={DriverRow}
            classes={classes}
            onDetailsClick={onDetailsClick}
            onEcoGradeClick={onEcoGradeClick}
          />
        </TableBody>
      </Table>
    </TableContainerWithHeight>
  );
};

DriversTable.propTypes = {
  classes: PropTypes.object,
  drivers: PropTypes.array,
  onDetailsClick: PropTypes.func,
  onEcoGradeClick: PropTypes.func,
  searchedDriver: PropTypes.string,
  height: PropTypes.number
};

export default compose(
  withStyles(useStyles),
)(DriversTable);
